<script>
  import { LayoutList } from 'lucide-svelte';

  export let iconClass = '';
</script>

<LayoutList class={iconClass} />
